import { IProjectModuleGasLiftLine } from '../../interfaces/iproject-module-gas-lift-line';
import { Project } from '../project';

export class ProjectModuleGasLiftLineBase {
  ProjectModuleGasLiftLineId: number;
  ProjectId: number;
  Description: string;
  PipeMaterial: string | null;
  PipeNominalDiameter: number | null;
  PressureRating: number | null;
  PressureRatingUnitOfMeasure: string | null;
  GasLiftLineLength: number | null;
  BoreLength: number | null;
  LineCrossings: number | null;
  RockPercent: number | null;
  IsComingled: boolean | null;
  IsPiggingLine: boolean | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Project?: Project;

  constructor(item?: IProjectModuleGasLiftLine) {
    if (item) {

      this.ProjectModuleGasLiftLineId = item.ProjectModuleGasLiftLineId;
      this.ProjectId = item.ProjectId;
      this.Description = item.Description;
      this.PipeMaterial = item.PipeMaterial;
      this.PipeNominalDiameter = item.PipeNominalDiameter;
      this.PressureRating = item.PressureRating;
      this.PressureRatingUnitOfMeasure = item.PressureRatingUnitOfMeasure;
      this.GasLiftLineLength = item.GasLiftLineLength;
      this.BoreLength = item.BoreLength;
      this.LineCrossings = item.LineCrossings;
      this.RockPercent = item.RockPercent;
      this.IsComingled = item.IsComingled;
      this.IsPiggingLine = item.IsPiggingLine;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Project = new Project(item.Project);
    }
  }
}